import { Dates } from './DatePickerRange.tsx'

export const NotCreated = ({ 
	dates, 
	setDates 
}: { 
	dates: ReturnType<typeof Dates.useDates>[0]
	setDates: ReturnType<typeof Dates.useDates>[1]
}) => (
	<Dates
		dates={dates}
		label='Added to Snaily'
		placeholder='Select date'
		setDates={setDates}
	/>
)
